import * as Yup from "yup";
import awesomeDebouncePromise from "awesome-debounce-promise";
import DataService from "features/Application/services/dataServices/typedDataService";

const debounceTimeMs = 300;
const maxNameLength = 128;
const maxFieldLength = 256;

const isUniqTemplate = awesomeDebouncePromise(DataService.groupTemplates.isUniqueTemplateName, debounceTimeMs);

const requiredDescription = (max: number) => {
  return Yup.string()
    .trim()
    .required("Description is required")
    .min(3, "Description must have at least 3 characters")
    .max(max, `Description cannot exceed ${max} characters`);
};
export const templateSchema = (initialValue?: string | null) => {
  return Yup.object().shape({
    name: getEditTemplateNameSchema(initialValue),
    description: requiredDescription(maxFieldLength),
  });
};

const getEditTemplateNameSchema = (initialValue?: string | null) => {
  let prev = initialValue;
  let isUniq = true;

  return Yup.string()
    .required("Template name is required")
    .max(maxNameLength, `Template name cannot exceed ${maxNameLength} characters`)
    .test("unique-template-name", "Template name should be unique", async (name: string) => {
      if (name === initialValue) return true;
      if (name && name !== prev) {
        isUniq = await isUniqTemplate(name);
        prev = name;
      }
      return isUniq;
    });
};
